const config = (typeof window !== 'undefined' ? window.__PORTAL_CONFIG__ : null) || {}

export const BASE_URL = config.BASE_URL || import.meta.env.VITE_BASE_URL

/** Относительный путь без своего baseURL — запрос к API портала. Сравнение по origin. */
export function isPortalRequest(url?: string, baseURL?: string): boolean {
  if (!url || !BASE_URL) return false
  try {
    const portal = new URL(BASE_URL)
    const target = new URL(url, baseURL || BASE_URL)
    return target.origin === portal.origin
  } catch {
    return false
  }
}
export const TIMEZONE = Number(config.TIMEZONE_OFFSET_HOURS ?? import.meta.env.VITE_TIMEZONE_OFFSET_HOURS ?? 3)
export const LOGTO_ENDPOINT = config.LOGTO_ENDPOINT || import.meta.env.VITE_LOGTO_ENDPOINT || ''
export const LOGTO_APP_ID = config.LOGTO_APP_ID || import.meta.env.VITE_LOGTO_APP_ID || ''
export const WEBPUSH_PUBLIC_KEY = config.WEBPUSH_PUBLIC_KEY || import.meta.env.VITE_WEBPUSH_PUBLIC_KEY || ''

/** Список фич меню (VITE_FEATURES). В K8s задаётся через portal-env.js до загрузки бандла. */
function resolvePortalFeatures(): string {
  if (typeof window !== 'undefined' && window.__PORTAL_FEATURES__ != null && window.__PORTAL_FEATURES__ !== '') {
    return window.__PORTAL_FEATURES__
  }
  return (import.meta.env.VITE_FEATURES as string | undefined) ?? ''
}

export const PORTAL_FEATURES = resolvePortalFeatures()

let enabledFeaturesCache: Set<string> | null = null

function getEnabledFeatures(): Set<string> {
  if (!enabledFeaturesCache) {
    enabledFeaturesCache = new Set(
      PORTAL_FEATURES.split(',')
        .map(feature => feature.trim())
        .filter(Boolean),
    )
  }

  return enabledFeaturesCache
}

export function isPortalFeatureEnabled(feature: string): boolean {
  return getEnabledFeatures().has(feature)
}

/** Фича Matrix в portal-env (`chat_matrix`). */
export function isChatMatrixFeatureEnabled(): boolean {
  return isPortalFeatureEnabled('chat_matrix')
}

/** Fast Matrix — основной клиент чатов портала. */
export function isChatMatrixEnabled(): boolean {
  return isChatMatrixFeatureEnabled()
}

/** Активный Matrix UI для общих подключений портала. */
export function getActiveChatModule(): 'matrix' | null {
  return isChatMatrixEnabled() ? 'matrix' : null
}
